define([
	"dojo/_base/declare",
	"underscore",
	"csi/enums",
	"csi/heading/_base",
	"csi/html",
	"csi/xml",
	"csi/locale",
	"csi/middleware/common",
	"csi/middleware/inline/InlinePopupService",
	"./Attribute",
	"./Container",
	"./Renderer",
	"./_EnumMixin",
], function(declare, _, enums, csiHeading, html, xml, locale, {convertNamesStoreDataToComponentItems}, {CONTROL_TYPE_MULTI_SELECT}, Attribute, Container, Renderer, _EnumMixin) {

	function _toSortEnumContainerValue(/*Any*/value, format) {
		// summary: return index of enum value in list
		var store = enums.getStore(xml.enumGetId(format));
		var item = store && store.get(value);
		return item ? item[store.indexProperty] : enums.getIndexForOldEnum(locale.getEnumName(value));
	};

	function _isInvalid(/*String*/format, /*String*/value) {
		var store = format ? enums.getStore(format) : enums.getStore(xml.enumGetId(value));
		return !store || (value && !store.get(value));
	}

	return declare([Container, _EnumMixin], {
		// Boolean: by default sort enum values stored in container (not currently used for enumvector and enummap)
		bSort: true,
		tagAction: "ActionEnum",

		_getAction: function() {
			// summary: restore editing for string containers
			return Attribute.prototype._getAction.call(this);
		},

		/**
		* Check enum is in the store or not
		* @param {object} ctx - context of the enum
		* @param {object} h  - heading info of the enum
		* @param {string} value -  enum value
		* @return {string} - invalid message 
		*/
		toFilterValueExtra: function(ctx, h, value) {
			// summary: if enum is no longer in EnumList, add extra information next to value in filter drop-down
			return _isInvalid(this._getFormat(ctx, h), value) ? ' (' + locale.resource("ActionEnum_Invalid") + ')' : null;
		},


		toFilterValueCSS: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// summary: if enum is no longer in EnumList, then style in filter drop-down
			return _isInvalid(this._getFormat(ctx, h), value) ? html.CSS_DISABLED_COLOR : null;
		},

		toHtmlQueryFilter: function(/*Context*/ctx, /*Spec*/spec, /*DOMNode*/refNode, /*Object*/params) {
			// summary: return widget for specifying query filter for attributes of this type and format
			var h = spec.heading;

			if (params.store == null) {
				params.store = enums.getStore(this._getFormat(ctx, h), params.value);
			}

			// DE20982 - do not reuse toHtmlDynamic as EnumAction will overwrite params.value
			return new InlineSelect(params);
		},

		/**
		 * @override
		 * provide specific operators for Enum Container
		 */
		getQuerySpec(ctx, h, spec) {
			var qs = this.inherited(arguments);
			qs.ops = csiHeading.QUERY_OPS.enumcontainer;
			return qs;
		},

		_getSortValues: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*String[]*/textValues) {
			var fmt = this._getFormat(ctx, h);

			return _.map(value, function(enumValue) {
				return _toSortEnumContainerValue(enumValue, fmt);
			});
		},

		/**
		 * @override
		 * Use custom sorting for enums
		 */
		formatValueForSorting: function(value, format, formattedValue) {
			if (value != null) {
				value = _toSortEnumContainerValue(value, format);
			}

			return value;
		},

		/**
		 * @override
		 * If uses Heading Dependency then use normal behavior; otherwise check for valid enum dependency
		 */
		hasValidDependency(ctx, h) {
			// NOTE: be careful as the Container renderer includes RendererStoreMixin which also has its own
			// override to hasValidDependency, and that should not be considered here
			return h.m_dependency ? Renderer.prototype.hasValidDependency.call(this, ctx, h) : this.enumHasValidDependsOn(ctx, h);
		},

		/** React */

		/**
		 * @override
		 */
		getReactControlOptions: async function(store, controller) {
			const data = await store.query();
			const options = convertNamesStoreDataToComponentItems(data, store);
			const value = this.getValueOptions(options, controller.oldValue);
			return {options, store, value};
		},

		/**
		 * @override
		 */
		getReactPlaceholderOptions: function(controller, ctx, h) {
			const {oldValue} = controller;
			const store = this.getStore(ctx, h, oldValue);
			if (_.isEmpty(oldValue)) {
				controller.oldValue = controller.newValue = [];
				return {options: [], value: null, store};
			}
			const data = [];
			oldValue.forEach(val => {
				const item = store.getFromMemory(val);
				if (item) {
					data.push(item);
				}
			});
			const options = convertNamesStoreDataToComponentItems(data, store);
			const value = this.getValueOptions(options, oldValue);
			return {options, value, store};
		},

		/**
		 * @param {context} ctx
		 * @return {string}
		 */
		getReactControlType: function(ctx) {
			return CONTROL_TYPE_MULTI_SELECT;
		},

		/** 
		 * return true if react renderer exists for given attribute type and should be used
		 */
		useReactInlineDialog() {
			return true;
		},
	});
});